"use strict";

var _classCallCheck = require("/vercel/path0/node_modules/@babel/runtime/helpers/classCallCheck.js");
var _createClass = require("/vercel/path0/node_modules/@babel/runtime/helpers/createClass.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Activation = void 0;
var Activation = /*#__PURE__*/function () {
  function Activation(options) {
    _classCallCheck(this, Activation);
    this.onIsActiveChanged = options.onIsActiveChanged;
    this.isActive = false;
    this.timers = [];
  }
  _createClass(Activation, [{
    key: "activate",
    value: function activate() {
      this.isActive = true;
      this.onIsActiveChanged({
        isActive: true
      });
    }
  }, {
    key: "deactivate",
    value: function deactivate() {
      this.isActive = false;
      this.onIsActiveChanged({
        isActive: false
      });
      this.clearTimers();
    }
  }, {
    key: "toggleActivation",
    value: function toggleActivation() {
      if (this.isActive) {
        this.deactivate();
      } else {
        this.activate();
      }
    }
  }, {
    key: "clearTimers",
    value: function clearTimers() {
      var timers = this.timers;
      while (timers.length) {
        var timer = timers.pop();
        if (timer === null || timer === void 0 ? void 0 : timer.id) {
          // @ts-expect-error
          clearTimeout(timer.id);
        }
      }
    }
  }, {
    key: "clearTimer",
    value: function clearTimer(timerName) {
      this.timers.forEach(function (timer) {
        if (timer.name === timerName) {
          // @ts-expect-error
          clearTimeout(timer.id);
        }
      });
    }
  }]);
  return Activation;
}();
exports.Activation = Activation;